import { render } from "./Feet.vue?vue&type=template&id=4c57edde&scoped=true"
import script from "./Feet.vue?vue&type=script&lang=js"
export * from "./Feet.vue?vue&type=script&lang=js"

import "./Feet.vue?vue&type=style&index=0&id=4c57edde&scoped=true&lang=css"

import exportComponent from "D:\\园域\\gfast-open\\huizhan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c57edde"]])

export default __exports__